import { render, staticRenderFns } from "./ArticleModalAdd.vue?vue&type=template&id=c3429898&scoped=true"
import script from "./ArticleModalAdd.vue?vue&type=script&lang=js"
export * from "./ArticleModalAdd.vue?vue&type=script&lang=js"
import style0 from "./ArticleModalAdd.vue?vue&type=style&index=0&id=c3429898&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3429898",
  null
  
)

export default component.exports